import protoRoot from "../proto-root";

function create({ playing, currentTime, commandId }) {
  const CommandPlayerState = protoRoot.lookupType(`comm.CommandPlayerState`);

  return CommandPlayerState.create({
    playing,
    currentTime,
    commandId
  });
}

export default {
  create
};

// message CommandPlayerState {
//     bool playing = 1;
//     int64 currentTime = 2;
//     string commandId = 3;
// }
